import React from "react";
import contact from "../../../config/contact";
import { Helmet } from "react-helmet";

const Privacy = () => {
    const {maintenanceEmail=""} = contact || {}
    return (
        <div className="legal">
            <Helmet>
                <title>Privacy Policy - Shopdm Pay</title>
            </Helmet>
            <div>
                <div className="h1">Shopdm Pay Privacy Policy</div>
                <div>Last updated: 1st September 2024</div>

                <div className="margin-top-1em">
                    At Shopdm Pay, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how Dom Software Ltd <b>("we", "our", "us", or "Shopdm Pay")</b> collects, uses, and protects information related to users <b>("you", "your")</b> of our services.
                </div>

                <div>
                    <div className="h2">1. Information We Collect</div>
                    We collect the following types of information to provide and improve our services:
                    <ul>
                        <li><strong>Transaction Information:</strong> Details about purchases made through Shopdm Pay, including the amount, currency, merchant name, and time of transaction.</li>
                        <li><strong>Billing Information:</strong> Information you provide during checkout, such as your name, email address, and billing address.</li>
                        <li><strong>Device and Usage Data:</strong> Information about the device and browser you use to access our services, including IP address, device type, and operating system.</li>
                        <li><strong>Support Interactions:</strong> Communications you send to our support team or submit via forms or emails.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">2. What We Don’t Collect</div>
                    Shopdm Pay does not collect, store, or process cardholder data (such as your credit or debit card number). All card-related transactions are processed by a PCI DSS-compliant third-party payment gateway.
                </div>

                <div>
                    <div className="h2">3. How We Use Your Information</div>
                    Your data is used strictly for the following purposes:
                    <ul>
                        <li>Processing payments and communicating with merchants.</li>
                        <li>Providing customer support and resolving disputes.</li>
                        <li>Detecting and preventing fraud or unauthorized activity.</li>
                        <li>Improving the performance and reliability of our platform.</li>
                        <li>Complying with legal obligations and regulatory requirements.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">4. Sharing Your Information</div>
                    We do not sell or rent your personal information. We only share your data with:
                    <ul>
                        <li>Merchants you transact with, to fulfill your order or provide a service.</li>
                        <li>Trusted service providers that help us operate our platform (e.g., payment processors, cloud storage providers).</li>
                        <li>Law enforcement or government authorities, if required by law.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">5. Data Security</div>
                    We apply industry-standard security measures to protect your personal data:
                    <ul>
                        <li>All data is encrypted in transit (TLS 1.2+) and at rest (AES-256) in Google Cloud infrastructure.</li>
                        <li>Strict access control policies and authentication procedures are enforced to prevent unauthorized access.</li>
                        <li>We routinely monitor our systems and update software to defend against known threats.</li>
                    </ul>
                </div>

                <div>
                    <div className="h2">6. Your Rights and Choices</div>
                    You have the right to:
                    <ul>
                        <li>Request access to or correction of your personal data.</li>
                        <li>Request that we delete your data, subject to legal obligations to retain certain information.</li>
                        <li>Withdraw consent for processing where consent was previously given.</li>
                    </ul>
                    To exercise any of these rights, please contact us at the email provided below.
                </div>

                <div>
                    <div className="h2">7. Data Retention</div>
                    We retain your information only as long as necessary for the purposes outlined in this policy, or as required by law (e.g., for regulatory or tax compliance).
                </div>

                <div>
                    <div className="h2">8. International Data Transfers</div>
                    All data is stored securely within Google Cloud infrastructure. If you are accessing Shopdm Pay from outside of the region in which we operate, please note that your data may be transferred across borders in accordance with applicable data protection laws.
                </div>

                <div>
                    <div className="h2">9. Changes To This Policy</div>
                    We may update this Privacy Policy from time to time. Any changes will be posted to our website, and we will notify users where required.
                    <br /><br />
                    This Policy was last updated: <strong>01/09/2024</strong>
                </div>

                <div>
                    <div className="h2">10. Contact Us</div>
                    If you have any questions or concerns about this Privacy Policy or your personal data, please contact us at: <br />
                    <strong>{maintenanceEmail}</strong> 
                </div>
            </div>
        </div>
    );
};

export default Privacy;